import { render, staticRenderFns } from "./MensajeFormulario.vue?vue&type=template&id=fab5b09e"
import script from "./MensajeFormulario.vue?vue&type=script&lang=js"
export * from "./MensajeFormulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports